

import Css from './Css.js';
import LeftDragBtnImg from '../../../Images/left_drag_btn.png';

//滑动选区的左边滑动按钮组件
function LeftDragBtn(props){

  const left = props.leftData.left;
  return (
    <>
      <div style={ Css.LeftDragBtn(left) }> 
        <img 
        style={ Css.img }
        src={ LeftDragBtnImg } 
        alt=""
        onMouseDown={ (e)=>{ props.onMouseDownDragBtn(e, 'left') } }
        ></img>
      </div>
    </>
  )
}

export default LeftDragBtn;